'use strict';

var chunkHL7FQXW2_js = require('./chunk-HL7FQXW2.js');

var n="api/v1/package";function t(o){let a={enableLoader:!0,enableSnackbar:!1};return chunkHL7FQXW2_js.a().postFile(n,o,a)}

exports.a = t;
